$(document).ready(function(){

    /* 
        Hero Slider 
    */
    var heroSliderEl = document.getElementById('ZxHero');
    if( heroSliderEl ) 
    {
      var hero_slider = new Splide('#ZxHero', {
          type: 'slide',
          perPage: 1,
          height: 670,
          rewind: true,
          arrows: true,
          pagination: true,
          drag: true,
          autoplay: false,
          breakpoints: {
              767: {
                  height: 500,
              }
          },
          video: {
              loop: false,
              mute: false,
              autoplay: false,
              hideControls: true
          }
      });
      hero_slider.mount(window.splide.Extensions);
    }

    /* 
        Featured Products
    */
    var splideOptions = {
      type: 'slide',
      perPage: 4,
      rewind: true,
      arrows: true,
      pagination: false,
      drag: true,
      autoplay: false,
      gap: 15,
      breakpoints: {
        1024: {
          perPage: 3,
        },
        768: {
          perPage: 2,
        },
        480: {
          perPage: 1,
        }
      }
    };
    var elms = document.getElementsByClassName('feature-products');
    for (var i = 0; i < elms.length; i++) 
    {
        new Splide(elms[i], splideOptions).mount();
    }

    /* 
        Info Box Carousel
    */
    var featured_products = {
        type: 'slide',
        perPage: 3,
        rewind: true,
        arrows: true,
        pagination: false,
        drag: true,
        autoplay: false,
        gap: 15,
        breakpoints: {
          1024: {
            perPage: 3,
          },
          768: {
            perPage: 2,
          },
          480: {
            perPage: 1,
          }
        }
    };
    var elms = document.getElementsByClassName('info-box-carousel');
    for (var i = 0; i < elms.length; i++) 
    {
        new Splide(elms[i], featured_products).mount();
    }

    /* 
        Horizontal Cards Carousel
    */
    var featured_products = {
        type: 'slide',
        perPage: 2,
        perMove: 1,
        rewind: true,
        arrows: true,
        pagination: false,
        drag: true,
        autoplay: false,
        gap: 15,
        breakpoints: {
          1024: {
            perPage: 1,
          },
          768: {
            perPage: 1,
          },
          480: {
            perPage: 1,
          }
        }
    };
    var elms = document.getElementsByClassName('zx-horizontal-cards-carousel');
    for (var i = 0; i < elms.length; i++) 
    {
        new Splide(elms[i], featured_products).mount();
    }

    // Product Single Page Accordions
    var acc = document.getElementsByClassName("zx-accordion");
    var i;
    if( acc )
    {
        for (i = 0; i < acc.length; i++) 
        {
            acc[i].addEventListener("click", function() {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if(panel.style.maxHeight) 
                {
                  panel.style.maxHeight = null;
                } 
                else 
                {
                  panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }
    }

    // Login Page
    $(document).on('click', '.zx-lb-right a', function(e){
        $(this).closest('.zx-login-wrapper').addClass('zx-hide');
        $('html, body').animate({
            scrollTop: $('#MainContent').offset().top
        }, 600);
    });
    $(document).on('click', '.zxlb-cancel a', function(e){
        $(document).find('.zx-login-wrapper').removeClass('zx-hide');
        $('html, body').animate({
            scrollTop: $('#MainContent').offset().top
        }, 600);
    });

    // Initialize Slider When Fetched - Related Products
    function initializeFeatureProductSliders() 
    {
        const splideOptions = {
          type: 'slide',
          perPage: 4,
          rewind: true,
          arrows: true,
          pagination: false,
          drag: true,
          autoplay: false,
          gap: 15,
          breakpoints: {
            1024: { perPage: 3 },
            768: { perPage: 2 },
            480: { perPage: 1 }
          }
        };
      
        const sliders = document.querySelectorAll('.feature-products-r');
      
        sliders.forEach(slider => {
          if (!slider.classList.contains('splide-initialized')) {
            new Splide(slider, splideOptions).mount();
            slider.classList.add('splide-initialized');
          }
        });
    }
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (
              node.nodeType === 1 && // Ensure it's an element
              node.classList.contains('feature-products-r')
            ) {
              initializeFeatureProductSliders(); // Re-init on new slider block
            }
      
            // If it's a container that *includes* feature-products-r
            if (
              node.nodeType === 1 &&
              node.querySelectorAll &&
              node.querySelector('.feature-products-r')
            ) {
              initializeFeatureProductSliders();
            }
          });
        });
      });  
    // Start observing a dynamic content wrapper (change as needed)
    const containerToObserve = document.querySelector('#main-content') || document.body;
    observer.observe(containerToObserve, { childList: true, subtree: true });

  
    var currentPath = window.location.pathname.toLowerCase();
  
    // Menu Active Link - Desktop
    document.querySelectorAll('.header__inline-menu a').forEach(link => {
      var linkPath = new URL(link.href, window.location.origin).pathname.toLowerCase();
      if(
        currentPath === linkPath ||
        currentPath.startsWith(linkPath + '/')
      ) 
      {
        link.classList.add('active');
        var details = link.closest('details');
        if (details) 
        {
          var summary = details.querySelector('summary');
          if (summary) summary.classList.add('active');
        }
      }
    });

    // Menu Active Link - Mobile
    document.querySelectorAll('.menu-drawer__navigation a').forEach(link => {
      var linkPath1 = new URL(link.href, window.location.origin).pathname.toLowerCase();
      if(
        currentPath === linkPath1 ||
        currentPath.startsWith(linkPath1 + '/')
      ) 
      {
        link.classList.add('active');
        var details = link.closest('details');
        if (details) 
        {
          var summary = details.querySelector('summary');
          if (summary) summary.classList.add('active');
        }
      }
    });

    /*
      Mega Menu
    */

    const caretIcon = `
      <svg class="icon icon-caret" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.960937 1.33594L1.57031 0.632812C2.6224 1.03906 3.90625 1.89323 5.42187 3.19531C6.91667 1.89323 8.20833 1.03906 9.29687 0.632812L9.89062 1.33594C9.75521 1.64323 9.52604 2.00521 9.20312 2.42187C8.88021 2.84375 8.5026 3.27604 8.07031 3.71875C7.64323 4.16146 7.19792 4.57292 6.73437 4.95312C6.27083 5.33854 5.83333 5.64844 5.42187 5.88281C5.01562 5.64844 4.58073 5.33854 4.11719 4.95312C3.65365 4.57292 3.20573 4.16146 2.77344 3.71875C2.34635 3.27604 1.97135 2.84375 1.64844 2.42187C1.32552 2.00521 1.09635 1.64323 0.960937 1.33594Z" fill="white"/>
      </svg>
    `;
/*
    document.querySelectorAll(".zx-mega-menu-wrapper").forEach(wrapper => {
      const handle = wrapper.dataset.mega_for;
      const targetLink = document.querySelector(`#HeaderMenu-${handle}`);

      if (targetLink) {
        targetLink.insertAdjacentHTML("beforeend", caretIcon);
        targetLink.insertAdjacentHTML("beforeend", `<button class="zx-open-mega" type="button"></button>`);
        targetLink.classList.add("zx-mega-style");
      }

      const toggleBtn = targetLink?.querySelector(".zx-open-mega");

      // Open / close only this wrapper
      toggleBtn?.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation(); // ✨ critical

        wrapper.classList.toggle("is-open");
        targetLink.classList.toggle("is-open");
      });

      // Close mega ONLY when clicking real menu items,
      // but ignore clicks on ENTERING mega itself
      document.querySelectorAll(".header__menu-item").forEach(item => {
        item.addEventListener("click", (e) => {

          // Block the auto-close when clicking the mega toggle
          if (e.target.closest(".zx-open-mega")) return;

          wrapper.classList.remove("is-open");
          targetLink.classList.remove("is-open");
        });
      });
    });
*/

    // ======================================
    // HOVER-BASED MEGA MENU
    // ======================================
    document.querySelectorAll(".zx-mega-menu-wrapper").forEach(wrapper => {
      const handle = wrapper.dataset.mega_for;
      const targetLink = document.querySelector(`#HeaderMenu-${handle}`);

      if (targetLink) {
        targetLink.insertAdjacentHTML("beforeend", caretIcon);
        targetLink.insertAdjacentHTML(
          "beforeend",
          `<button class="zx-open-mega" type="button"></button>`
        );
        targetLink.classList.add("zx-mega-style");
      }

      // Open mega on hover
      targetLink?.addEventListener("mouseenter", () => {
        closeAllMenus();
        wrapper.classList.add("is-open");
        targetLink.classList.add("is-open");
      });

      // Close when leaving wrapper
      wrapper.addEventListener("mouseleave", () => {
        wrapper.classList.remove("is-open");
        targetLink.classList.remove("is-open");
      });
    });


    // ======================================
    // HOVER-BASED DEFAULT <details> DROPDOWNS
    // ======================================
    document.querySelectorAll(".header__inline-menu details").forEach(item => {

      item.addEventListener("mouseenter", () => {
        closeAllMenus();
        item.setAttribute("open", true);
      });

      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });


// ======================================
// CLOSE EVERYTHING UTILITY
// ======================================
function closeAllMenus() {
  // Mega menus
  document.querySelectorAll(".zx-mega-menu-wrapper.is-open")
    .forEach(el => el.classList.remove("is-open"));
  document.querySelectorAll(".zx-mega-style.is-open")
    .forEach(el => el.classList.remove("is-open"));

  // <details> dropdowns
  document.querySelectorAll(".header__inline-menu details[open]")
    .forEach(el => el.removeAttribute("open"));
}

  const titles = document.querySelectorAll(".jdgm-carousel-title");
  titles.forEach(function (title) {
    title.addEventListener("click", function () {
      window.open("https://judge.me/reviews/stores/leafberri.com", "_blank");
    });
  });






});